<kendo-dialog [title]="canEdit ? 'Add Reason for Delay' : 'View Reason for Delay'" (close)="closeDialog()"
    [width]="'90vw'" [height]="'90vh'" [minWidth]="'1166'" (click)="$event.stopPropagation()">
    <div class="loading-container" *ngIf="loadSpinner">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
    </div>
    <!-- CPSE View -->
    <ng-container *ngIf="canEdit">
        <div>This case is out of compliance. Please select the reason(s) for the delay. *</div>
        <div class="enter-rfd-container">
            <kendo-multicolumncombobox [data]="availableReasons" textField="description" valueField="id"
                [(ngModel)]="reasonForDelay">
                <kendo-combobox-column field="reasonForDelay" title="Reason for Delay"
                    [style]="{ 'white-space': 'normal', 'word-wrap': 'break-word' }">
                    <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                        {{ dataItem.description }}
                    </ng-template>
                </kendo-combobox-column>

                <kendo-combobox-column field="description" title="Full Description"
                    [style]="{ 'white-space': 'normal', 'word-wrap': 'break-word' }">
                    <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                        <span>{{ dataItem.extDescr }}</span>
                    </ng-template>
                </kendo-combobox-column>

            </kendo-multicolumncombobox>
            <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" (click)="addReasonForDelay()" [disabled]="!reasonForDelay">Add
            </button>
        </div>

        <div *ngIf="form">
            <form class="k-form k-form-md k-w-full" [formGroup]="form">
                <div formArrayName="reasons" class="list-of-reasons-container" [class.selected-reasons-panel]="hasActiveReasons">
                    <div *ngFor="let reason of reasonsControls; let i = index;" [formGroupName]="i" class="k-w-full">
                        <ng-container *ngIf="reason.get('isActive')?.value">
                            <kendo-expansionpanel [title]="reason.get('reasonForDelay')?.value?.description">
                                <div class="rfd-content">
                                    <div class="date-added-by">
                                        <div>
                                            <span class="small-text-secondary">Date added</span>
                                            <div>{{ reason.get('dateAdded')?.value |date : "MM/dd/yyyy"}}</div>
                                        </div>

                                        <div>
                                            <span class="small-text-secondary">Added by</span>
                                            <div>{{ reason.get('addedBy')?.value }}</div>
                                        </div>
                                    </div>

                                    <kendo-formfield>
                                        <kendo-floatinglabel text="Reason for Delay *">
                                            <kendo-dropdownlist [data]="getAvailableReasonsForEntry(reason.get('reasonForDelay')?.value?.id)"
                                                [textField]="'description'" formControlName="reasonForDelay"
                                                [valueField]="'id'">
                                            </kendo-dropdownlist>
                                        </kendo-floatinglabel>
                                    </kendo-formfield>

                                    <kendo-formfield>
                                        <kendo-label text="Description " [for]="description">
                                        </kendo-label>
                                        <kendo-textarea [fillMode]="'outline'" formControlName="description"
                                            #description placeholder="Type Here" [rows]="3" resizable="vertical">
                                        </kendo-textarea>
                                    </kendo-formfield>

                                    <kendo-formfield>
                                        <kendo-fileselect appFileRestrictions class="fileselect-wrapper__select"
                                            formControlName="files" [showFileList]="true" [multiple]="true">
                                        </kendo-fileselect>
                                        <app-documents [documents]="reason.get('existingDocuments')?.value"
                                            [editMode]="true" (ondeleteDocument)="onDeleteDocument($event, reason)">
                                        </app-documents>
                                    </kendo-formfield>
                                </div>

                                <div class="rfd-divider"></div>

                                <button kendoButton [fillMode]="'outline'" [themeColor]="'error'"
                                    (click)="removeReasonForDelay(i)">
                                    Remove
                                </button>
                            </kendo-expansionpanel>
                        </ng-container>

                    </div>
                </div>
            </form>
        </div>
    </ng-container>

    <!-- Non CPSE View -->
    <ng-container *ngIf="!canEdit">
        <div *ngIf="form">
            <form class="k-form k-form-md k-w-full" [formGroup]="form">
                <div formArrayName="reasons" class="list-of-reasons-container">
                    <div *ngFor="let reason of reasonsControls; let i = index;" [formGroupName]="i" class="k-w-full">
                        <kendo-expansionpanel [title]="reason.get('reasonForDelay')?.value?.description">
                            <div class="rfd-content">
                                <div class="date-added-by">
                                    <div>
                                        <span class="small-text-secondary">Date added</span>
                                        <div>{{ reason.get('dateAdded')?.value |date : "MM/dd/yyyy"}}</div>
                                    </div>

                                    <div>
                                        <span class="small-text-secondary">Added by</span>
                                        <div>{{ reason.get('addedBy')?.value }}</div>
                                    </div>
                                </div>


                                <div>
                                    <span class="small-text-secondary">Reason for Delay</span>
                                    <div>{{ reason.get('reasonForDelay')?.value?.description }}</div>
                                </div>


                                <div>
                                    <span class="small-text-secondary">Description</span>
                                    <div>{{ reason.get('description')?.value || '--' }}</div>
                                </div>

                                <div *ngIf="reason.get('existingDocuments')?.value?.length">
                                    <app-documents [documents]="reason.get('existingDocuments')?.value"
                                        [editMode]="false">
                                    </app-documents>
                                </div>
                            </div>
                        </kendo-expansionpanel>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>

    <kendo-dialog-actions>
        <button kendoButton (click)="save()" [fillMode]="'solid'" [themeColor]="'primary'" *ngIf="canEdit"
            [disabled]="!hasActiveReasons || loadSpinner">
            Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>